import {connect} from 'react-redux';
import {ThermocyclerControls as Component} from './ThermocyclerControls';
import {
  showModal,
  setModal,

  setThermocyclerLid,
  setThermocyclerVolume,

  setThermocyclerDurations,
  setThermocyclerCurrentTime,
  setThermocyclerTotalTime,
  setThermocyclerTotalElapsedTime,
  setThermocyclerRunning,
  setThermocyclerSaved,
  setThermocyclerInnerSection,
  setThermocyclerEditConnection,
  setThermocyclerSection,
  setThermocyclerDialog,
  setThermocyclerDialogDisplay,
  updateThermocyclerSequence,

  updateThermocyclerSequenceTemp,
  updateThermocyclerSequenceTime,
  updateThermocyclerSequenceRepeat,

  addThermocyclerSequence,
  removeThermocyclerSequence,
  eraseThermocyclerSequence
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    type: state.notebook.protocolSection.scene.apparatus.thermocyclers[ownProps.id-1].type,

    currentSection:state.notebook.protocolSection.scene.apparatus.thermocyclers[ownProps.id-1].currentSection,
    currentDialog:state.notebook.protocolSection.scene.apparatus.thermocyclers[ownProps.id-1].currentDialog,
    innerSection:state.notebook.protocolSection.scene.apparatus.thermocyclers[ownProps.id-1].innerSection,

    displayDialog:state.notebook.protocolSection.scene.apparatus.thermocyclers[ownProps.id-1].displayDialog,
    editConnection:state.notebook.protocolSection.scene.apparatus.thermocyclers[ownProps.id-1].editConnection,

    open:state.notebook.protocolSection.scene.apparatus.thermocyclers[ownProps.id-1].open,
    volume:state.notebook.protocolSection.scene.apparatus.thermocyclers[ownProps.id-1].volume,
    lid:state.notebook.protocolSection.scene.apparatus.thermocyclers[ownProps.id-1].lid,
    saved:state.notebook.protocolSection.scene.apparatus.thermocyclers[ownProps.id-1].saved,
    totalTime:state.notebook.protocolSection.scene.apparatus.thermocyclers[ownProps.id-1].totalTime,
    durations:state.notebook.protocolSection.scene.apparatus.thermocyclers[ownProps.id-1].durations,
    running:state.notebook.protocolSection.scene.apparatus.thermocyclers[ownProps.id-1].running,
    currentTime:state.notebook.protocolSection.scene.apparatus.thermocyclers[ownProps.id-1].currentTime,
    totalElapsedTime:state.notebook.protocolSection.scene.apparatus.thermocyclers[ownProps.id-1].totalElapsedTime,
    sequence: state.notebook.protocolSection.scene.apparatus.thermocyclers[ownProps.id-1].sequence,
    levelSelected: state.notebook.levelSelected
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) => {
      dispatch(showModal(data))
    },
    setModal: (data) => {
      dispatch(setModal(data))
    },
    setThermocyclerLid: (data) => {
      dispatch(setThermocyclerLid(data))
    },
    setThermocyclerVolume: (data) => {
      dispatch(setThermocyclerVolume(data))
    },
    setThermocyclerDurations: (data) => {
      dispatch(setThermocyclerDurations(data))
    },
    setThermocyclerRunning: (data) => {
      dispatch(setThermocyclerRunning(data))
    },
    setThermocyclerCurrentTime: (data) => {
      dispatch(setThermocyclerCurrentTime(data))
    },
    setThermocyclerTotalTime: (data) => {
      dispatch(setThermocyclerTotalTime(data))
    },
    setThermocyclerTotalElapsedTime: (data) => {
      dispatch(setThermocyclerTotalElapsedTime(data))
    },
    setThermocyclerSaved: (data) => {
      dispatch(setThermocyclerSaved(data))
    },
    setThermocyclerInnerSection: (data) => {
      dispatch(setThermocyclerInnerSection(data))
    },
    setThermocyclerEditConnection: (data) => {
      dispatch(setThermocyclerEditConnection(data))
    },
    setThermocyclerSection: (data) => {
      dispatch(setThermocyclerSection(data))
    },
    setThermocyclerDialog: (data) => {
      dispatch(setThermocyclerDialog(data))
    },
    setThermocyclerDialogDisplay: (data) => {
      dispatch(setThermocyclerDialogDisplay(data))
    },
    updateThermocyclerSequence: (data) => {
      dispatch(updateThermocyclerSequence(data))
    },

    updateThermocyclerSequenceTemp: (data) => {
      dispatch(updateThermocyclerSequenceTemp(data))
    },
    updateThermocyclerSequenceTime: (data) => {
      dispatch(updateThermocyclerSequenceTime(data))
    },
    updateThermocyclerSequenceRepeat: (data) => {
      dispatch(updateThermocyclerSequenceRepeat(data))
    },
    addThermocyclerSequence: (data) => {
      dispatch(addThermocyclerSequence(data))
    },
    removeThermocyclerSequence: (data) => {
      dispatch(removeThermocyclerSequence(data))
    },
    eraseThermocyclerSequence: (data) => {
      dispatch(eraseThermocyclerSequence(data))
    }
  };
}

export const ThermocyclerControls = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
